// extracted by mini-css-extract-plugin
export default {"loading":"OR5c1L9t","spin":"o6u1MItt"};